import { tryGetHostApi } from "./externalApi";
import { isFeatureEnabled } from "./VelocityApi";
export async function getAepBadgeState() {
    const aepApi = await tryGetHostApi("Aep", 2, 2);
    if (aepApi) {
        return await aepApi.aepBadgeState;
    }
    return false;
}
export async function getAepBadgeId() {
    const aepApi = await tryGetHostApi("Aep", 2, 2);
    if (aepApi) {
        return await aepApi.aepBadgeId;
    }
    return "unknown";
}
export async function getAepMissedBadgeIds() {
    if (isFeatureEnabled("Feature_AEPEvolvedNotifications")) {
        const aepApi = await tryGetHostApi("Aep", 5, 5);
        if (aepApi) {
            return await aepApi.aepMissedBadgeIds;
        }
    }
    return new Array();
}
export async function getAepMissedBadgeIdsPayload() {
    if (isFeatureEnabled("Feature_AEPBadgeIdsPayload")) {
        const aepApi = await tryGetHostApi("Aep", 6, 6);
        if (aepApi) {
            return await aepApi.aepMissedBadgeIdsPayload;
        }
    }
    return new Array();
}
export async function getAepPayloadContentType() {
    const aepApi = await tryGetHostApi("Aep", 1, 1);
    if (aepApi) {
        return await aepApi.aepPayloadContentType;
    }
    return "unknown";
}
export async function notifyAEPPayloadUpdate(payload, widgetId, instanceId, isOffline) {
    const aepApi = await tryGetHostApi("Aep", 1, 1);
    if (aepApi) {
        return await aepApi.notifyAEPPayloadUpdate(payload, widgetId, instanceId, isOffline);
    }
}
export async function getSettings() {
    const aepApi = await tryGetHostApi("Aep", 3, 1);
    if (aepApi) {
        return await aepApi.getSettings();
    }
    return "unknown";
}
export async function updateSetting(settings) {
    const aepApi = await tryGetHostApi("Aep", 3, 1);
    if (aepApi) {
        const updatedSettings = { Settings: [settings] };
        let value = JSON.stringify(updatedSettings);
        return await aepApi.setSettings(value);
    }
}
export async function setSettings(isHoverEnabled, isBadgingEnabled, isRotationEnabled) {
    const aepApi = await tryGetHostApi("Aep", 3, 1);
    if (aepApi) {
        // JSON definition in Host App uses Upper Camel Case
        const updatedSettings = {
            Settings: [{ HoverEnabled: isHoverEnabled }, { RotationEnabled: isRotationEnabled }, { BadgingEnabled: isBadgingEnabled }],
        };
        let value = JSON.stringify(updatedSettings);
        return await aepApi.setSettings(value);
    }
}
